import {NgModule} from "@angular/core";
import {Http, RequestOptions, XHRBackend} from "@angular/http";
import {CerbaAuthService, httpFactory} from "@digicerba/common";
import {
  HttpClient,
  IAuditWebServiceClient,
  ICatalogueExamenWebServiceClient,
  ICorrespondantWebServiceClient,
  IFavorisWebServiceClient,
  IGedWebServiceClient,
  IMiseAJourExamenWebServiceClient,
  INotificationCatalogueExamenWebServiceClient,
  INotificationsCommonWebServiceClient,
  IReferentielWebServiceClient,
  IUserInformationsWebServiceClient
} from "@resources/resources";

import {ResourcesClient} from "./resources.client";
import { CORRESPONDANT_CLIENT, USER_INFO_CLIENT } from "@digicerba/common/resources/tokens/injectionTokens";

var resources: Array<any> = [
  /** Liste des resources du fichier resources.ts*/
  ICorrespondantWebServiceClient,
  IAuditWebServiceClient,
  IUserInformationsWebServiceClient,
  IReferentielWebServiceClient,
  IMiseAJourExamenWebServiceClient,
  ICatalogueExamenWebServiceClient,
  IFavorisWebServiceClient,
  INotificationsCommonWebServiceClient,
  IGedWebServiceClient,
  INotificationCatalogueExamenWebServiceClient,
  CerbaAuthService,
  { provide : CORRESPONDANT_CLIENT, useClass : ICorrespondantWebServiceClient},
  { provide : USER_INFO_CLIENT, useClass : IUserInformationsWebServiceClient}

];

@NgModule({
  providers: [...resources,
    {
      provide: Http,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions, CerbaAuthService]
    },
    {provide: HttpClient, useClass: ResourcesClient}]
})
export class ResourcesModule {

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/common/resources/resources.module.ts